import { defaultProps } from './defaultEventProps';

export const logout = () => {
    return {
        name: 'Logout',
        details: defaultProps,
    };
};